import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterComponent } from './filter.component';
import { FormsModule } from '@angular/forms';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { DateRangeModule } from '../date-range/date-range.module';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';

@NgModule({
  declarations: [
    FilterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NzDropDownModule,
    NzDatePickerModule,
    DateRangeModule,
    NzBadgeModule,
    NzCollapseModule
  ],
  exports: [
    FilterComponent,
  ]
})
export class FilterModule { }